import type {BreadcrumbItem} from '@/modules/foundation/components/breadcrumb';
import ContentBlocks from '@/modules/foundation/sanity/content-blocks/ContentBlocks';
import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';
import PageHead from '@/modules/foundation/sanity/page-head/PageHead';
import type {NemndFrontpageQueryResult} from '@/sanity/schemas/types';

type Props = {
	page: NemndFrontpageQueryResult;
};

export default function Page({page}: Props) {
	const {content, pageHeadings, parent} = page ?? {};

	const breadcrumb: BreadcrumbItem[] = [
		{
			href: internalLinkToHref(parent?._type),
			title: parent?.title ?? 'Mangler tittel',
		},
		{
			href: internalLinkToHref(page?._type, page?.slug?.current),
			title: page?.title ?? page?.pageHeadings?.[0]?.heading ?? 'Mangler tittel',
		},
	];

	return (
		<>
			{pageHeadings && <PageHead pageHeads={pageHeadings} breadcrumb={breadcrumb} />}
			{content && content.length > 0 && <ContentBlocks content={content} />}
		</>
	);
}
